import { useContext } from 'react';
import Compare from '../Compare';
import Stack from '../../../shared/layouts/Stack';
import Box from '../../../shared/layouts/Box';
import CategoryHeader from '../CategoryHeader';
import { CompareContext } from '../ComparePage';
import {useTranslation} from "react-i18next";

const SECTION = 'partner_contact';

const ComparePartnerContactSection = () => {
  const {
    ownPartnerData,
    otherPartnerData,
    handlePartnerDataChange,
    showOnlyDiff,
    hasDiff,
    shouldShow,
    contactInfoFields,
    hasSectionCopiedFields,
  } = useContext(CompareContext);

  const { t } = useTranslation();

  const handleDataChange = (e) => {
    handlePartnerDataChange(e, SECTION);
  };

  if (
    showOnlyDiff &&
    !hasSectionCopiedFields(SECTION) &&
    !hasDiff(contactInfoFields, { ...ownPartnerData }, { ...otherPartnerData })
  )
    return null;

  return (
    <Stack space="l">
      <CategoryHeader>
        <span>{t('Contactgegevens partner')}</span>
        <span>{t('Contactgegevens partner')}</span>
      </CategoryHeader>
      <Stack space="m">
        {shouldShow(
          'phone_number',
          ownPartnerData,
          otherPartnerData,
          SECTION
        ) && (
          <Compare
            label={t("Telefoonnummer")}
            name="phone_number"
            section={SECTION}
            leftValue={ownPartnerData?.phone_number}
            rightValue={otherPartnerData?.phone_number}
            onUpdate={handleDataChange}
          />
        )}
        {shouldShow('email', ownPartnerData, otherPartnerData, SECTION) && (
          <Box css={{ overflowWrap: 'anywhere' }}>
            <Compare
              label={t("Emailadres")}
              name="email"
              section={SECTION}
              leftValue={ownPartnerData?.email}
              rightValue={otherPartnerData?.email}
              onUpdate={handleDataChange}
            />
          </Box>
        )}
      </Stack>
    </Stack>
  );
};

export default ComparePartnerContactSection;
